import React, { forwardRef } from 'react'
import { Slide } from '@material-ui/core'

const Transition = (props, ref) => <Slide direction='up' ref={ref} {...props} />

export default forwardRef(Transition)
